var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CompassSkeleton", {
        staticClass: "fake-general-information-title",
        attrs: { size: "x-large" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "fake-general-information-block" }, [
        _c(
          "div",
          [
            _c("CompassSkeleton", { staticClass: "fake-label" }),
            _vm._v(" "),
            _c("CompassSkeleton", { staticClass: "fake-date" }),
            _vm._v(" "),
            _c("CompassSkeleton", { staticClass: "fake-owner" }),
            _vm._v(" "),
            _c("CompassSkeleton", { staticClass: "fake-description" })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("CompassSkeleton", {
              attrs: { variant: "square", size: "small" }
            }),
            _vm._v(" "),
            _c("CompassSkeleton", { staticClass: "fake-date-data" }),
            _vm._v(" "),
            _c("CompassSkeleton", { staticClass: "fake-owner-data" }),
            _vm._v(" "),
            _vm._l(2, function(_, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("CompassSkeleton", { attrs: { variant: "square" } }),
                  _vm._v(" "),
                  _c("CompassSkeleton", {
                    staticClass: "fake-description-data"
                  })
                ],
                1
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("CompassSkeleton", {
        staticClass: "fake-related-title",
        attrs: { size: "x-large" }
      }),
      _vm._v(" "),
      _c("CompassSkeleton", {
        staticClass: "fake-related-block",
        attrs: { variant: "block" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }